import { render, staticRenderFns } from "./DIRCsRes.vue?vue&type=template&id=04de3930&scoped=true&"
import script from "./DIRCsRes.vue?vue&type=script&lang=js&"
export * from "./DIRCsRes.vue?vue&type=script&lang=js&"
import style0 from "./DIRCsRes.vue?vue&type=style&index=0&id=04de3930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04de3930",
  null
  
)

export default component.exports